import { Component, OnInit , OnDestroy, Renderer2 , ElementRef, ViewChild, QueryList, ViewChildren} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { EchexpaymentService } from '../echexpayment.service';
import { LocalstorageService } from '../localstorage.service';
import { NgForm } from '@angular/forms';
import { Location } from '@angular/common';

@Component({
  selector: 'echxpayment-plan',
  templateUrl: './planform.component.html',
  styleUrls: ['./plan.component.css']
})
export class EditplanComponent implements OnInit, OnDestroy {
	@ViewChild('f') myForm : NgForm;
	createplan: boolean = false;
	editplan: boolean = true;
	public token: string;
	public plan: any = {interval:'', status: ''};
	public addChecks = false
	public addUsers = false;
	public check_no_of_users:boolean = false;
	public check_no_of_cheque:boolean = false;
	public val_plan_name:boolean=false;
	public val_plan_id:boolean=false;
	public val_amount:boolean=false;
	public val_appear_in:boolean=false;
	public val_interval:boolean=false;
	public val_trial_period:boolean=false;
	public val_status:boolean=false;

	public enter_cheque:boolean=false;
	public send_cheque:boolean=false;
	public create_secure_url_link:boolean=false;
	public create_bank_auth_url_link:boolean=false;
	public showWarning: boolean = false;
	
	public show_nocheck: boolean = false;
	public show_nouser: boolean = false;
	public zerovalidate: boolean = false;

	public link_options = [
		{ name:'Enter Check', value: 'enter_cheque', selected: false },
		{ name:'Send Check', value: 'send_cheque', selected: false },
		{ name:'Create Secure Url Link', value: 'create_secure_url_link', selected: false },
		{ name:'Create Bank Auth Url Link', value: 'create_bank_auth_url_link', selected: false }
	];
	NamecharacterLimitReached: { [key: string]: boolean } = {};
	
	constructor(private router: Router, private Location: Location, private renderer: Renderer2, private toastr: ToastrService, private elementRef: ElementRef, private echexpaymentService :EchexpaymentService, private localStorageService: LocalstorageService, private route: ActivatedRoute) { 
	this.router = router;
	var currentUser = this.localStorageService.getData("currentUserToken");
	this.token =  currentUser.data.user_token;
	}

	ngOnInit() {
		this.getEditPlan();
	}

	ngOnDestroy() {
		this.toastr.clear();
	  }

	ngAfterViewInit() {
		this.renderer.selectRootElement('#Initial_focus').focus();
	}
	//eventHandler
	eventHandler(){
		this.val_plan_name = false;
		this.val_plan_id = false;
		this.val_amount = false;
		this.val_appear_in = false;
		this.val_interval = false;
		this.val_trial_period = false;
		this.val_status = false;
		this.check_no_of_users = false;
		this.check_no_of_cheque = false;

		this.enter_cheque = false;
		this.send_cheque = false;
		this.create_secure_url_link = false;
		this.create_bank_auth_url_link = false;

}
	
	addNumberOfChecks(value){
		 if(value == true){
			this.addChecks = true;
		 }
		 if(value == false){
			this.addChecks = false;
		 }
	}

	addNumberOfUser(value){
		if(value == true){
		 this.addUsers = true;
		}
		if(value == false){
		 this.addUsers = false;
		}
	}
	// get plan details by _id
	getEditPlan() {
		let params: any = this.route.snapshot.params;
		let data = {
		  token:this.token,
		  id:params.id,
		}
		let responseData = <any>{};
		this.echexpaymentService.getEditPlanData(data).subscribe(
		   response => {
				responseData = response;
			  this.plan = responseData.data;
			  if(responseData.data.settings){
			  
				  if(responseData.data.settings.no_of_user){
					this.check_no_of_users =  responseData.data.settings.no_of_user;
					this.plan.no_of_user = responseData.data.settings.no_of_user
					// this.plan.check_no_of_users = (parseInt(responseData.data.settings.no_of_user) > 0 ? true  : false);
					this.plan.check_no_of_users = true;

					// if(this.plan.check_no_of_users){
					// 	this.show_nouser = true
					// }
					this.addUsers = true;
				  }
				  if(responseData.data.settings.no_of_cheque){
					this.plan.no_of_cheque = responseData.data.settings.no_of_cheque
					this.check_no_of_cheque =  responseData.data.settings.no_of_cheque;
					//this.plan.check_no_of_cheque = (parseInt(responseData.data.settings.no_of_cheque) > 0 ? true  : false);
					this.plan.check_no_of_cheque = true;
					this.addChecks = true;
					// if(this.plan.check_no_of_users){
					// 	this.show_nocheck = true
					// }
				  }
				  this.plan.enter_cheque = (responseData.data.settings.enter_cheque == 'yes')?true:false;
				  this.enter_cheque =  (responseData.data.settings.enter_cheque == 'yes')?true:false;
				  
				  this.plan.send_cheque = (responseData.data.settings.send_cheque == 'yes')?true:false;
				  this.send_cheque =  (responseData.data.settings.send_cheque == 'yes')?true:false;

				  this.plan.create_secure_url_link = (responseData.data.settings.create_secure_url_link == 'yes')?true:false;
				  this.create_secure_url_link =  (responseData.data.settings.create_secure_url_link == 'yes')?true:false;

				  this.plan.create_bank_auth_url_link = (responseData.data.settings.create_bank_auth_url_link == 'yes')?true:false;
				  this.create_bank_auth_url_link =  (responseData.data.settings.create_bank_auth_url_link == 'yes')?true:false;

				  for (let option of this.link_options) {
					if(this.enter_cheque  == true && option.value == 'enter_cheque'){
						option.selected = true;
					}
					if(this.send_cheque  == true && option.value == 'send_cheque'){
						option.selected = true;
					}
					if(this.create_secure_url_link == true && option.value == 'create_secure_url_link'){
						option.selected = true;
					}
					if(this.create_bank_auth_url_link == true && option.value == 'create_bank_auth_url_link'){
						option.selected = true;
					}
				  }
				  
				}
		   },
		   error => {
			 responseData = error;
			 this.toastr.error(responseData.error.message, 'Failed!');
		   }
		);
	}


	@ViewChild('submitButton') submitButton: ElementRef;
	moveNext(nextInput: HTMLInputElement, checkbox: number = 0) {
		if(checkbox === 1){
			this.focusFirstCheckbox();
		} else if(checkbox === 5){
			const formValue = this.myForm.value;
			 if(formValue.check_no_of_users === true){
				this.renderer.selectRootElement('#plan8').focus();
			} else{
				this.renderer.selectRootElement('#FocusStatus').focus();
			}
		} else if(checkbox === 2){
			if (this.submitButton && this.submitButton.nativeElement) {
				this.submitButton.nativeElement.focus();
				this.submitButton.nativeElement.click();
			}
		} else{
			nextInput && nextInput.focus();
		}
	}

	@ViewChildren('Focus_Entercheck') checkboxRefs: QueryList<ElementRef>;
	@ViewChild('no_cheque') noChequeInput: ElementRef;
	focusFirstCheckbox() {
	  const firstCheckbox = this.checkboxRefs.first;
	  if (firstCheckbox && firstCheckbox.nativeElement) {
		firstCheckbox.nativeElement.focus();
	  } else if (this.noChequeInput && this.noChequeInput.nativeElement) {
		this.noChequeInput.nativeElement.focus();

	  }
	}

	@ViewChild('selectBox') selectBox: ElementRef;
	focusNextCheckbox(index: number) {
		const formValue = this.myForm.value;
		const nextIndex = index + 1;
		if (nextIndex < this.checkboxRefs.length) {
		  const nextCheckbox = this.checkboxRefs.toArray()[nextIndex];
		  if (nextCheckbox && nextCheckbox.nativeElement) {
			nextCheckbox.nativeElement.focus();
		  }
		} else {
			if(formValue.check_no_of_cheque === true){
				this.renderer.selectRootElement('#plan7').focus();
			} else if(formValue.check_no_of_users === true){
				this.renderer.selectRootElement('#plan8').focus();
			} else {
				if (this.selectBox && this.selectBox.nativeElement) {
					this.selectBox.nativeElement.focus();
				}
			}
		}
	  }
	// Focus error field
	focusFirstInvalidControlPlus(): void {
		const firstElementWithErrors: HTMLElement = this.elementRef.nativeElement.querySelector(`form .ng-invalid`);
		if (firstElementWithErrors) {
			firstElementWithErrors.focus();
		}
	}

	validateFields(event: any) {
		if(event === '0'){
			this.show_nocheck = true
		} else{
			this.show_nocheck = false
		}
	  }
	  validate_userFields(event:any){
		if(event === '0'){
			this.show_nouser = true
		} else{
			this.show_nouser = false
		}
	  }

	// Update plan
	updatePlan(data){
		this.focusFirstInvalidControlPlus();   //focus field
		if(data.value.no_of_cheque === '0' && data.value.no_of_user === '0'){
			this.zerovalidate = true;
			this.show_nocheck = true;
			this.show_nouser = true;
	   } else{
			this.zerovalidate = false;
			if(data.valid){
				let model: any = data.value;
				let params: any = this.route.snapshot.params;
				model.token = this.token;
				model._id = params.id;
				for (let option of this.link_options) {
					let optionVal = option.value;
					
					if (option.selected && optionVal == 'enter_cheque') {
						model.enter_cheque = 'yes';
					}
					if (!option.selected && optionVal == 'enter_cheque') {
						model.enter_cheque = 'no';
					}
					if (option.selected && optionVal == 'send_cheque') {
						model.send_cheque = 'yes';
					}
					if (!option.selected && optionVal == 'send_cheque'){
						model.send_cheque = 'no';
					}
					if (option.selected && optionVal == 'create_secure_url_link') {
						model.create_secure_url_link = 'yes';
					}
					if (!option.selected && optionVal == 'create_secure_url_link'){
						model.create_secure_url_link = 'no';
					}
					if (option.selected && optionVal == 'create_bank_auth_url_link') {
						model.create_bank_auth_url_link = 'yes';
					}
					if (!option.selected && optionVal == 'create_bank_auth_url_link'){
						model.create_bank_auth_url_link = 'no';
					}
				}
				let responseData = <any>{};
				this.echexpaymentService.updatePlan(model).subscribe(
				response => {
					responseData = response;
					this.toastr.success(responseData.message, 'Success!');
					this.router.navigate(['/plan']);
				},
				error => {
					responseData = error;
					this.toastr.error(responseData.error.message, 'Failed!');
				}
				);
			}
		}
	}



	NameCharacterLimit(event: any, fieldName: string) {
		const maxTextLength = 25; // Maximum text length of 20 characters
		const inputChar = event.key;
		const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
		const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
	
		if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
		  return;
		}
	
		const inputValue = event.target.value;
	
		if (inputValue.length >= maxTextLength) {
		  if (allowedKeys.indexOf(inputChar) === -1) {
			this.NamecharacterLimitReached[fieldName] = true; // Set the validation flag to true to show the warning message
			setTimeout(() => {
			  this.NamecharacterLimitReached[fieldName] = false; // Hide the warning message after 3 seconds
			}, 3000);
			event.preventDefault(); // Prevent entering the exceeded character
		  }
		}
	  }
	
	  isNameLimitReached(fieldName: string): boolean {
		return this.NamecharacterLimitReached[fieldName];
	  }

	  goBack(){
         this.Location.back();
	  }

	   // disallow 0
	   validateNumberInput(event: any) {
		const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
		const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
	  
		if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
		  // Allow the default behavior for certain keys
		  return;
		}
	  
		if (!/^\d+$/.test(event.key)) {
		  // Prevent input if it's not a digit
		  event.preventDefault();
		}
	  }


	  DisallowZero(event: any) {
        const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
        const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
      
        if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
          // Allow the default behavior for certain keys
          return;
        }
      
        const inputValue = event.target.value;
        const caretStart = event.target.selectionStart;
        const caretEnd = event.target.selectionEnd;
        const modifiedValue = inputValue.slice(0, caretStart) + event.key + inputValue.slice(caretEnd);
        
        if (modifiedValue !== '' && !/^\d*\.?\d*$/.test(modifiedValue)) { 
        //  this.showWarning = false; // Hide the warning message
          event.preventDefault(); // Prevent invalid input
          return;
        }
        const regex = /^\d{0,9}(\.\d{0,2})?$/;
        const maxValue = 999999999;
        if (!regex.test(modifiedValue) || parseFloat(modifiedValue) > maxValue) {
          if (parseFloat(modifiedValue) > maxValue) {
            this.showWarning = true;
            setTimeout(() => {
              this.showWarning = false;
            }, 3000);
            event.preventDefault();
          } else{
			this.showWarning = false;
		  }
          event.preventDefault();
        } 
      }

	  	//setAmountValue
		setAmountValueForBankAuth(amount){
			// if(amount) {
			// 	this.plan.amount = parseFloat(amount).toFixed(2);
			// }      
		}
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/plan/editplan.component.ts